<p-table #dt [value]="itemsSource$ | async | filter:searchDefinitions:searchTerm" [columns]="columns"
    [(selection)]="selectedItems" [paginator]="paginator" [rows]="pageSize" [responsive]="true"
    [rowsPerPageOptions]="rowsPerPageOptions" [resizableColumns]="true" columnResizeMode="expand"
    [selectionMode]="selectionMode" [lazy]="isLoadLazy" [totalRecords]="totalRecords"
    (onRowExpand)="onRowExpandEvent($event)" (onLazyLoad)="loadGridLazy($event)" [loading]="loading"
    [filters]="filters" [scrollable]="scrollable" scrollHeight="flex" [editMode]="editMode" [dataKey]="dataKey"
    [globalFilterFields]="globalFilterFields" selectionMode="single" [sortMode]="'multiple'" (onSort)="onSort($event)"
    (onRowSelect)="onRowSelectEvent($event)" (onRowUnselect)="onRowUnselectEvent($event)"
    [currentPageReportTemplate]="totalRecordsText" [showCurrentPageReport]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngIf="isFilterable||rowExpand" [ngClass]="columnClass()">
                <button *ngIf="isFilterable" pButton type="button" label="{{labelSearch | translate}}"
                    icon="pi pi-search" iconPos="right" class="p-button-text searchBtn"
                    (click)="toggleSearch($event)"></button>
            </th>
            <th *ngFor="let col of columns" [hidden]="col.hidden" [pSortableColumn]="col.sortable ? col.field : '' "
                [ngClass]="columnClass(col.width, col.headerClass)">
                <p-sortIcon *ngIf="col.sortable" [field]="col.field" ></p-sortIcon>
                {{col.headerTranslate|translate}}
            </th>


        </tr>
        <tr class="search-row" *ngIf="isFilterable && search">
            <th [hidden]="hiddenSelectors"></th>
            <th>
                <button class="clearBtn" pButton pRipple type="button" label="{{'ROULETTE.CLEAR'|translate}}"
                    (click)="clearFilter(columns)"></button>
            </th>
            <th *ngFor="let col of columns" [hidden]="col.hidden">
                <div class="wrap-search-element">
                    <span
                        *ngIf="col.filter && ((col.type== inputTemplate.comment) ||(!col.type || col.type== inputTemplate) || col.type==inputTemplate.tooltip || (col.type == inputTemplate.number || col.type == inputTemplate.amount|| col.type == inputTemplate.percent||col.type== inputTemplate.active))"
                        class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                    </span>
                    <input *ngIf="col.filter && (col.type== inputTemplate.comment)" pInputText type="text"
                        (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)"
                        [value]="dt.filters[col.field] ? $any(dt.filters[col.field]).value : ''">
                    <input
                        *ngIf="col.filter && (!col.type || col.type== inputTemplate||col.type== inputTemplate.active)"
                        pInputText type="text" (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)"
                        [value]="dt.filters[col.field] ? $any(dt.filters[col.field]).value : ''">
                    <input *ngIf="col.filter && col.type==inputTemplate.tooltip" pInputText type="text"
                        (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)"
                        [value]="dt.filters[col.field] ? $any(dt.filters[col.field]).value : ''">
                    <input *ngIf="col.filter && (col.type == inputTemplate.number || col.type == inputTemplate.amount)"
                        pInputText type="number"
                        (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)"
                        [value]="dt.filters[col.field] ? $any(dt.filters[col.field]).value : ''">
                    <input *ngIf="col.filter && (col.type == inputTemplate.percent)" pInputText type="text"
                        (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)"
                        [value]="dt.filters[col.field] ? $any(dt.filters[col.field]).value : ''">
                    <span style="width: 100%;"
                        *ngIf="col.filter && (col.type==inputTemplate.longDate ||col.type==inputTemplate.date || col.type==inputTemplate.shortDate || col.type==inputTemplate.dateTime)">
                        <p-calendar [(ngModel)]="col.fromDateFilter" appendTo="body" [showIcon]="true" [locale]="he"
                            placeholder="{{'ROULETTE.FROM_DATE' | translate}}" dateFormat="dd/mm/yy" hourFormat="24"
                            [showTime]="col.type==inputTemplate.longDate || col.type==inputTemplate.dateTime"
                            (onBlur)="sortDate(col)" (onSelect)="sortDate(col)">
                        </p-calendar>
                        <p-calendar [(ngModel)]="col.toDateFilter" appendTo="body" [showIcon]="true" [locale]="he"
                            placeholder="{{'ROULETTE.TO_DATE' | translate}}" dateFormat="dd/mm/yy"
                            [showTime]="col.type==inputTemplate.longDate || col.type==inputTemplate.dateTime"
                            (onBlur)="sortDate(col)" (onSelect)="sortDate(col)"                          >
                        </p-calendar>
                    </span>
                    <p-dropdown appendTo="body"
                        *ngIf="col.filter && (col.type==inputTemplate.enumComboBox)  || (col.type==inputTemplate.circleWithEditPopup) || (col.type==inputTemplate.status&&col.filter)"
                        [options]="col.comboOptionsFilter" [showClear]="true"
                        placeholder="{{'GENERAL.SELECT'|translate}}"
                        (onChange)="dt.filter($event.value,col.field,col.filterMatchMode)"
                        styleClass="ui-column-filter">
                    </p-dropdown>
                </div>
            </th>


        </tr>
    </ng-template>

    <!-- <ng-template pTemplate="body" let-users let-editing="editing">
        <tr [pEditableRow]="users">
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="users.UserName" required>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{users.UserName}}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>

                <p-cellEditor class="eye">
                    <ng-template pTemplate="input">
                        <input [type]="ppassword" [(ngModel)]="users.Password" [toggleMask]="true">
                        <button class="passwordButton" (click)="onClick()" [icon]="icon" pButton pRipple type="button">
                        </button>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <input [type]="ppassword" [(ngModel)]="users.Password" class="label" disabled [toggleMask]="true">
                        <button class="passwordButton" (click)="onClick()" [icon]="icon" pButton pRipple type="button">
                        </button>
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input type="email" pInputText [(ngModel)]="users.Email" required email>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{users.Email}}
                    </ng-template>
                </p-cellEditor>
            </td> -->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-editing="editing" let-columns="columns"
        let-expanded="expanded">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData"
            [ngClass]="rowData[fieldForRowClass] === valueForRowClass ? 'row-specific-class':'' "
            (click)="isClickableRow"
            (dblclick)="viewRowDetails(rowData.CustomerId,rowData)">
            <td *ngIf="rowExpand">
                <a href="#" [pRowToggler]="rowData">
                    <i
                        [ngClass]="expanded ? 'pi pi-chevron-down' :direction ?'pi pi-chevron-left':'pi pi-chevron-right'"></i>
                </a>
            </td>
            <td *ngIf="isFilterable && !rowExpand">
            </td>
            <td *ngFor="let col of columns" [hidden]="col.hidden" class="ui-resizable-column {{col.field}}"
                tooltipPosition="left" [pTooltip]="col.tooltip" (click)="isClickableRow"
                [ngClass]="[col.valueFieldClassName? col.enumFieldForClassName? 'class'+rowData[col.valueFieldClassName] :toString(rowData[col.valueFieldClassName]) : '' , col.customClass? col.customClass(rowData[col.field]) : '']">
                <ng-container [ngSwitch]="col.type">
                    <span *ngSwitchCase="inputTemplate.password">
                        {{rowData[col.field]|passwordViewPipe}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.enumComboBox">
                        <p>{{rowData[col.field] | enumTranslate:col.enumType:col.enumName }}
                        </p>
                    </span>
                    <span class="enumComboBoxWithAction" *ngSwitchCase="inputTemplate.enumComboBoxWithAction">
                        <p *ngIf="rowData[col.field]!=1">{{rowData[col.field] | enumTranslate:col.enumType:col.enumName }}
                        </p>
                        <ng-container *ngTemplateOutlet="col.outletTemplate;context:{$implicit: rowData}">
                        </ng-container>
                    </span>
                    <span *ngSwitchCase="inputTemplate.status">             
                        <p class="edit">{{rowData[col.field] | enumTranslate:col.enumType:col.enumName }}</p>
                    </span>              
                    <span *ngSwitchCase="inputTemplate.percent">
                        {{rowData[col.field] | percent}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.longDate">
                        {{rowData[col.field] | date:'dd/MM/yyyy hh:mm:ss'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.fullDate">
                        {{rowData[col.field] | date:'dd/MM/yyyy'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.date">
                        {{rowData[col.field] | date:'dd.MM.yy'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.shortDate">
                        {{rowData[col.field] | date:'MM/yyyy'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.hebrewDate">
                        {{rowData[col.field] | date:'MMMM yyyy'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.dateTime">
                        {{rowData[col.field] | date:'dd.MM.yy hh:mm:ss'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.amount" dir="ltr">
                        {{rowData[col.field] | number:'1.2-2'}}
                    </span>
                    <span *ngSwitchCase="inputTemplate.amount" dir="ltr">
                        {{rowData[col.field] | number:'1.2-2'}}
                    </span>      
                    <span *ngSwitchCase="inputTemplate.tooltip">
                        <p [pTooltip]="rowData[col.field]">{{rowData[col.field] }}</p>
                    </span>
                    <span *ngSwitchCase="inputTemplate.bool">
                        <div *ngIf="!rowData[col.field]">
                            <i class="pi pi-times-circle" style="color: red;"></i>
                        </div>
                        <div *ngIf="rowData[col.field]">
                            <i class="pi pi-check-circle" style="color: green;"></i>
                        </div>
                    </span>
                    <span *ngSwitchCase="inputTemplate.active">
                        {{'ROULETTE.INACTIVE'|translate}}
                    </span>
                    <span 
                    *ngSwitchCase="inputTemplate.icon" 
                    [ngStyle]="{'background-image': 'url(' + rowData[col.field] + ')', 
                                'width': '34px', 
                                'height': '34px', 
                                'display': 'inline-block', 
                                'background-size': 'contain', 
                                'background-repeat': 'no-repeat'}">
                </span>
                    <span *ngSwitchCase="inputTemplate.link">
                        <a  target="_blank" rel="noopener noreferrer" href="{{rowData[col.field]}}"> {{rowData[col.field]}}</a>
                    </span>
                    <span  *ngSwitchCase="inputTemplate.sumWithCurrency">
                        {{rowData[col.field]| currency:rowData[col.currencyFieldName]:'symbol':'3.0'}}
                     </span>
                    <span *ngSwitchCase="inputTemplate.number" [dir]="col.dir?col.dir:'rtl'"
                        [ngClass]="{'negative':rowData[col.field] < 0, 'positive': rowData[col.field] > 0,'zero':  rowData[col.field] == 0 ,'number':true}">

                        {{rowData[col.field]}}</span>
            
                    <span *ngSwitchCase="inputTemplate.template">
                        <!-- <span>
                            <div *ngIf="!rowData[col.field]">
                                <i *ngIf="showActions" class="fa fa-exclamation-circle" style="color: red;"></i>
                            </div>
                            <div *ngIf="rowData[col.field]">
                                <i class="fa fa-check" style="color: green;"></i>
                            </div>
                        </span> -->
                        <ng-container *ngTemplateOutlet="col.outletTemplate;context:{$implicit: rowData}">
                        </ng-container>
                    </span>
                    <span *ngSwitchDefault>
                        <p *ngIf="!col.translateKey"> {{rowData[col.field]}}</p>
                        <p *ngIf="col.translateKey"> {{col.translateKey+rowData[col.field] | translate}}</p>
                    </span>
                </ng-container>
            </td>
            <!-- <td>
                <button *ngIf="rowExpand" type="button" pButton pRipple [pRowToggler]="rowData"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-left'"></button>
            </td> -->
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
            <td [attr.colspan]="columns.length">
                {{ 'READONLY_TABLE.NO_DATA_FOUND'|translate }}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
        <tr class="row-expand">
            <td [attr.colspan]="showColums +11">
                <ng-container *ngTemplateOutlet="rowExpandTemplate;context:{$implicit: rowData}"></ng-container>
            </td>
        </tr>
    </ng-template>
    
</p-table>